export default "__VITE_ASSET__108d8bd5__"